export interface StatamicGlobalRequest {
    handle: string
}

export const useStatamicGlobals = () => {
    const statamic = useStatamic()

    const getGlobal = <T>(req: StatamicGlobalRequest) =>
        statamic<T>(`/globals/${req.handle}`)

    return {
        getGlobal,
    }
}
